import {getScope} from './state';

const errorFields = {
    payment: [
        {
            id: 'custom-price-amount-input-wrapper',
            regex: /Amount should be/i,
        },
        {
            selector: '.new-card-form .table-form-inline .field-card-number .field-wrapper',
            regex: /credit card|declined|expired/i,
        },
        {
            selector: '.new-card-form .table-form-inline .field-card-cvv .field-wrapper',
            regex: /cvv/i,
        },
        {
            selector: '.new-card-form .table-form-inline .field-card-postal-code .field-wrapper',
            regex: /zip|postal|not seem to be valid/i,
        },
        {
            selector: '.new-card-form .table-form-inline .field-card-expiry-month .field-wrapper',
            regex: /date/i,
        }
    ],
    gift: [
        {
            id: 'recipientEmail',
            regex: /email/i,
        }
    ],
};

/**
 * Clear out the validation errors
 */
const removeValidationErrors = () => {
    const scope = getScope();
    const formType = scope.selectedTerm.type;

    errorFields[formType].forEach( (fieldInfo) => {
        const targetField = fieldInfo.id ? document.getElementById(fieldInfo.id) : document.querySelector(fieldInfo.selector);
        targetField?.classList.remove('checkout__error', 'checkout__input--invalid', 'field-wrapper--error');
        if (targetField?.nextElementSibling?.classList.contains('checkout__error') ) {
            targetField.nextElementSibling.remove();
        }

    });
};

let hadErrors = false;

/**
 *  Handle checkout errors by watching the scope.error property.  This populates when the error bar contains message strings
 */
const handleCheckoutErrors = () => {
    let scope = getScope();

    scope.$watch('hasErrors()', () => {
        scope = getScope();
        // if there are no errors in the scope.errors watcher and there had previously been an error in the checkout, clear out the errors
        if (!scope?.errors?.length && hadErrors) {
            removeValidationErrors();
        }
        if (scope?.errors?.length) {
            hadErrors = true;
            scope.errors.forEach( (scopeError) => {
                const formType = scope.selectedTerm.type;
                const errorClass = formType !== 'payment' && 'checkout__input--invalid';

                // parse out the error and match it to the css selector to put it under the input
                errorFields[formType].forEach( (fieldInfo) => {
                    const targetField = fieldInfo.id ? document.getElementById(fieldInfo.id) : document.querySelector(fieldInfo.selector);
                    if (targetField && targetField && scopeError.message.match(fieldInfo.regex) ) {
                        targetField.classList.add(errorClass, 'checkout_error', 'field-wrapper--error');

                        // dont add a new error if it already has one
                        if (!targetField.nextElementSibling?.classList.contains('checkout__error') ) {
                            const tempDiv = document.createElement("div");
                            tempDiv.classList.add('checkout__error');
                            tempDiv.textContent = scopeError.message;
                            targetField.insertAdjacentElement("afterend", tempDiv);
                        }
                    }
                });
                /**
                  *  Add error only to field that needs to be changed
                  *  From piano support email:
                  *    If the CVV or expiration date entered is invalid, the error message "Credit card has been declined" will show.
                  *    If the credit card number is invalid, the error "Invalid credit card number" will show.
                  *    If the zip code entered is invalid, the error "The card information you provided does not seem to be valid" should appear.
                 **/
            }
            );
        }
    });
};

export {handleCheckoutErrors};
